'use strict';

export class LinkConfirmation {
    ignoreList = [
        'essencehealthcare.com',
        'everythingessence.com',
        'myessencehealthcare.com',
        'lumeris.io',
        'lumeris.com',
        'essence-ipc.destinationrx.com',
        'essence1.destinationrx.com',
        'wpenginepowered.com',
        'wpengine.com'
    ];

    customConfirmationsList = [
        {
            hosts: ['www.medicare.gov', 'medicare.gov'],
            message: 'By clicking this link you will be leaving the Essence Healthcare website and taken to Medicare.gov.'
        },
        {
            hosts: ['www.ssa.gov', 'ssa.gov'],
            message: 'By clicking this link you will be leaving the Essence Healthcare website and taken to the Social Security Administration website.'
        },
        {
            hosts: ['www.cms.gov', 'cms.gov'],
            message: 'By clicking this link you will be leaving the Essence Healthcare website website and taken to the Centers for Medicare &amp; Medicaid Services website.'
        },
        {
            hosts: ['www.medlineplus.gov', 'medlineplus.gov'],
            message: 'By clicking this link you will be leaving the Essence Healthcare website website and taken to the MedlinePlus website.'
        },
        {
            hosts: ['www.shiphelp.org', 'shiphelp.org'],
            message: 'By clicking this link you will be leaving the Essence Healthcare website and taken to the State Health Insurance Assistance Program website.'
        },
        {
            hosts: ['www.rrb.gov', 'rrb.gov'],
            message: 'By clicking this link you will be leaving the Essence Healthcare website and taken to the Railroad Retirement Board website.'
        },
        {
            hosts: ['www.oasisnet.org', 'oasisnet.org'],
            message: 'By clicking this link you will be leaving the Essence Healthcare website and taken to The Oasis Institute website.'
        },
        {
            hosts: ['www.st-louis.oasisnet.org', 'st-louis.oasisnet.org'],
            message: 'By clicking this link, you will be leaving the Essence Healthcare website and taken to the St. Louis Oasis website.'
        },
        {
            hosts: ['www.prnewswire.com', 'prnewswire.com'],
            message: 'By clicking this link, you will be leaving the Essence Healthcare website and taken to the PR Newswire.',
            urls: [
                'https://www.prnewswire.com/news-releases/essence-healthcare-named-among-the-best-performing-medicare-advantage-plans-for-2026-302582169.html',
                'https://www.prnewswire.com/news-releases/essence-healthcare-announces-2026-medicare-advantage-plans-in-chicagoland-302571920.html',
                'https://www.prnewswire.com/news-releases/essence-healthcare-announces-2026-medicare-advantage-plans-in-central-arkansas-302571934.html',
                'https://www.prnewswire.com/news-releases/essence-healthcare-announces-2026-medicare-advantage-plans-in-louisville-and-lexington-302571926.html',
                'https://www.prnewswire.com/news-releases/essence-healthcare-announces-2026-medicare-advantage-plans-in-southwest-missouri-and-northwest-arkansas-302571922.html',
                'https://www.prnewswire.com/news-releases/essence-healthcare-announces-2026-medicare-advantage-plans-in-mid-missouri-302571930.html',
                'https://www.prnewswire.com/news-releases/essence-healthcare-announces-2026-medicare-advantage-plans-in-greater-st-louis-302571916.html'
            ]
        },
        {
            hosts: ['www.digitallearn.org', 'digitallearn.org'],
            message: 'By clicking this link, you will be leaving the Essence Healthcare website and taken to the Digital Learn website.'
        },
        {
            hosts: ['www.agingahead.org', 'agingahead.org'],
            message: 'By clicking this link, you will be leaving the Essence Healthcare website and taken to the Aging Ahead website.'
        },
        {
            hosts: ['www.helpingpeople.org', 'helpingpeople.org'],
            message: 'By clicking this link, you will be leaving the Essence Healthcare website and taken to the United Way of Greater St. Louis website.'
        },
        {
            hosts: ['www.tridentcare.com', 'tridentcare.com'],
            message: 'By clicking this link, you will be leaving the Essence Healthcare website and taken to the TridentCare website.'
        },
        {
            hosts: ['www.ouraring.com', 'ouraring.com'],
            message: 'By clicking this link, you will be leaving the Essence Healthcare website and taken to the ŌURA website.'
        },
        {
            hosts: ['www.instagram.com', 'instagram.com'],
            message: 'By clicking this link, you will be leaving the Essence Healthcare website and taken to the Instagram website.'
        },
        {
            hosts: ['www.linkedin.com', 'linkedin.com'],
            message: 'By clicking this link, you will be leaving the Essence Healthcare website and taken to the LinkedIn website.'
        },
        {
            hosts: ['www.tiktok.com', 'tiktok.com'],
            message: 'By clicking this link, you will be leaving the Essence Healthcare website and taken to the TikTok website.'
        },
        {
            hosts: ['www.youtube.com', 'youtube.com'],
            message: 'By clicking this link, you will be leaving the Essence Healthcare website and taken to the YouTube website.'
        },
        {
            hosts: ['report.syntrio.com', 'syntrio.com'],
            message: 'By clicking this link, you will be leaving the Essence Healthcare website and taken to the Syntrio website.'
        }
    ];

    constructor(options = {}) {
        this.ignoreList = (options.ignoreList) ? options.ignoreList : this.ignoreList;

        this.customConfirmationsList = (options.customConfirmationsList) ? options.customConfirmationsList : this.customConfirmationsList;

        this.bind();
    }

    bind() {
        document.body.addEventListener('click', this.onBodyClick);
    }

    isIgnoredLink(url) {
        return this.ignoreList.some(domain => url.hostname.endsWith(domain));
    }

    isCurrentHost(url) {
        return url.hostname === window.location.hostname;
    }

    isTelLink(url) {
        return url.protocol === 'tel:';
    }

    isSmsLink(url) {
        return url.protocol === 'sms:';
    }

    isEmailLink(url) {
        return url.protocol === 'mailto:';
    }

    isGoogleMapsLink(url) {
        return url.href.startsWith('https://www.google.com/maps/');
    }

    getConfirmLinkMessage(url) {
        if (!url) return null;

        const link = new URL(url);
        const defaultText = window.EHI?.externalLinkConfirmDefault ?? '';
        let message = `${defaultText} ${link}\n`;

        for (const item of this.customConfirmationsList) {
            if (item.hosts.includes(link.hostname)) {
                message = item.message;
                break;
            }
        }

        return message;
    }

    onBodyClick = (event) => {
        const el = event.target.closest('a');

        if (!el) {
            return;
        }

        if (el.matches('#google_translate_element a, a[data-toggle="tab"], a[data-dt-idx]')) {
            return;
        }

        const href = el.getAttribute('href');

        if (!href || href === '#') {
            return;
        }

        const url = new URL(el.href, window.location.href);

        if (this.isCurrentHost(url) || this.isTelLink(url) || this.isEmailLink(url) || this.isSmsLink(url) || this.isGoogleMapsLink(url) || this.isIgnoredLink(url)) {
            return;
        }

        let message = window.EHI?.externalLinkConfirmDefault ?? 'By clicking this link you will be leaving our website and taken to:';

        message = `${message} ${el.href}\n`;

        for (const item of this.customConfirmationsList) {
            if (item.hosts.includes(url.hostname)) {
                message = item.message;
                break;
            }
        }

        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'external_link_click' }}));

        if (!confirm(message)) {
            event.preventDefault();
        }
    }
}